import baseHttp from './baseHttp';

// List invoices for the partner's restaurant. Backend route is a POST that
// accepts an optional { status } filter and returns { invoices: [...] }.
export const getInvoices = (restaurantId, params = {}) =>
  baseHttp.post(`/api/v1/restaurants/${restaurantId}/invoices`, params).then((r) => r.data);

// Total unpaid amount across the restaurant's invoices.
export const getUnpaidAmount = (restaurantId) =>
  baseHttp.get(`/api/v1/restaurants/${restaurantId}/amount`).then((r) => r.data);

// Fetch an invoice PDF as a Blob (simple "bon de livraison" or detailed facture).
export const downloadInvoicePdf = (restaurantId, invoiceId, detailed = false) =>
  baseHttp
    .get(
      `/api/v1/restaurants/${restaurantId}/invoices/${invoiceId}/download${detailed ? '-detailed' : ''}`,
      { responseType: 'blob' }
    )
    .then((r) => r.data);

// Trigger a browser download for a Blob.
export const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
